import {PAYMENT_CODES} from '../../payment-codes-enum';

PaymentCodesListService.SERVICE_NAME = 'paymentCodesListService';

export default function PaymentCodesListService(
    tripAPI
) {
    'ngInject';

    Object.assign(this, {
        regexChecker,
        getPaymentCodes,
        isHierarchicalPaymentCode,
        isFreeTextCodeVisible,
        isMaskedInputCodeVisible,
        isPredefinedDropdownCodeVisible,
        isFixedValueCodeVisible,
        isMaskDropdownCodeVisible,
        isDropdownMaskCodeVisible,
        hasParentPaymentCode,
    });

    function regexChecker(regExp) {
        const text = regExp.match(/\(([^)]+)\)/)[1];
        let res = regExp;
        let loverCaseText;
        if (text.match(/^[A-Z]/)) {
            loverCaseText = text.toLocaleLowerCase();
            res = regExp.replace(text, text + '|' + loverCaseText);
        }
        return res;
    }

    function getPaymentCodes(codeId, searchString) {
        return tripAPI.fetchPaymentCodes({paymentCodeId: codeId, value: searchString});
    }

    function isHierarchicalPaymentCode(code) {
        return code.PaymentCodeFieldTypeId === PAYMENT_CODES.HIERARCHICAL_CODES;
    }

    function hasParentPaymentCode(code) {
        return !!code.ParentPaymentCodeId;
    }

    function isFreeTextCodeVisible(code) {
        return code.PaymentCodeFieldTypeId === PAYMENT_CODES.FREE_TEXT
            && !hasParentPaymentCode(code);
    }

    function isMaskedInputCodeVisible(code) {
        return code.PaymentCodeFieldTypeId === PAYMENT_CODES.MASKED_INPUT
            && !hasParentPaymentCode(code);
    }

    function isPredefinedDropdownCodeVisible(code) {
        return code.PaymentCodeFieldTypeId === PAYMENT_CODES.PREDEFINED_DROPDOWN
            && !hasParentPaymentCode(code);
    }

    function isFixedValueCodeVisible(code) {
        return code.PaymentCodeFieldTypeId === PAYMENT_CODES.FIXED_VALUE
            && !hasParentPaymentCode(code);
    }

    function isMaskDropdownCodeVisible(code) {
        return code.PaymentCodeFieldTypeId === PAYMENT_CODES.MASK_DROPDOWN
            && !hasParentPaymentCode(code);
    }

    function isDropdownMaskCodeVisible(code) {
        return code.PaymentCodeFieldTypeId === PAYMENT_CODES.DROPDOWN_MASK
            && !hasParentPaymentCode(code);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-container/payment-codes-list/payment-codes-list-service.js